import * as React from "react";
import { singleton } from "logic/singleton";
const defaultContext = {
  focusedWidget: void 0,
  setWidgetFocusing: () => {
  },
  setWidgetEditing: () => {
  },
  unsetWidgetFocusing: () => {
  },
  unsetWidgetEditing: () => {
  }
};
const WidgetFocus = React.createContext(defaultContext);
export default singleton("contexts.WidgetFocus", () => WidgetFocus);
